module.exports = __webpack_public_path__ + "img/TW.74b88030.svg";